import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { originalDocVerification } from "./sopDataTemplate";

interface AllProps {
  data: originalDocVerification;
  handleOriginalDocVerifyChange: any;
}

interface AllState {
  isOptionOpen: boolean;
  bgColor: string;
}

export class OriginalDocVerify extends Component<AllProps, AllState> {
  state: AllState = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
  };

  // Add default props to handle undefined data
  static defaultProps = {
    data: {} as originalDocVerification,
  };

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };

  handleInputChange = <K extends keyof originalDocVerification>(
    name: K,
    val: originalDocVerification[K]
  ) => {
    const { data } = this.props;
    
    // Ensure data exists before modifying
    if (!data) return;
    
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    
    if (this.props.handleOriginalDocVerifyChange) {
      this.props.handleOriginalDocVerifyChange(data);
    }
  };

  render() {
    const { data } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    
    // Add safe navigation for data
    if (!data) {
      return (
        <div className="collapse-section count-doc-verify">
          <Accordion>
            <Card>
              <Accordion.Toggle
                style={{ background: bgColor }}
                as={Card.Header}
                eventKey="7"
              >
                <h5>
                  <b>Original Document Verification</b>
                </h5>
                <i
                  className={`icon feather icon-plus`}
                  style={{
                    color: "black",
                    fontSize: "17px",
                    fontWeight: "bold",
                    float: "right",
                  }}
                />
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  <div>Loading data...</div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      );
    }

    // Use optional chaining for bgColor access
    const headerBgColor = data?.bgColor || bgColor;
    
    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: headerBgColor }}
              as={Card.Header}
              eventKey="7"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Original Document Verification</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="7">
              <Card.Body>
                <div>
                  <div className="row mb-10">
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Title Deed Original availability
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="isIAAvailable"
                          type="radio"
                          checked={data.isIAAvailable ==true}
                          onChange={() =>
                            this.handleInputChange("isIAAvailable", true)
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="isIAAvailable"
                          type="radio"
                          checked={data.isIAAvailable !== true}
                          onChange={() =>
                            this.handleInputChange("isIAAvailable", false)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        (N-1) Immedite parent document for title deed original
                        availabilty
                      </label>

                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="immediateParentDocAvailable"
                          type="radio"
                          checked={data.immediateParentDocAvailable === true}
                          onChange={() =>
                            this.handleInputChange(
                              "immediateParentDocAvailable",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="immediateParentDocAvailable"
                          type="radio"
                          checked={data.immediateParentDocAvailable !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "immediateParentDocAvailable",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Last 13 Years document original availabilty
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="last13YearsDocAvailable"
                          type="radio"
                          checked={data.last13YearsDocAvailable === true}
                          onChange={() =>
                            this.handleInputChange(
                              "last13YearsDocAvailable",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="last13YearsDocAvailable"
                          type="radio"
                          checked={data.last13YearsDocAvailable !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "last13YearsDocAvailable",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Same Extent document original availability
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="sameExtentDocAvailable"
                          type="radio"
                          checked={data.sameExtentDocAvailable === true}
                          onChange={() =>
                            this.handleInputChange(
                              "sameExtentDocAvailable",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="sameExtentDocAvailable"
                          type="radio"
                          checked={data.sameExtentDocAvailable !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "sameExtentDocAvailable",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Larger Extent documents wrongly mentioned original in
                        LOD
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="largerExtentDocWronglyMentioned"
                          type="radio"
                          checked={data.largerExtentDocWronglyMentioned === true}
                          onChange={() =>
                            this.handleInputChange(
                              "largerExtentDocWronglyMentioned",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="largerExtentDocWronglyMentioned"
                          type="radio"
                          checked={data.largerExtentDocWronglyMentioned !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "largerExtentDocWronglyMentioned",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Pre Disbursement Verified
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="preDisbursementVerified"
                          type="radio"
                          checked={data.preDisbursementVerified === true}
                          onChange={() =>
                            this.handleInputChange(
                              "preDisbursementVerified",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="preDisbursementVerified"
                          type="radio"
                          checked={data.preDisbursementVerified !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "preDisbursementVerified",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Post Disbursement Verified
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="postDisbursementVerified"
                          type="radio"
                          checked={data.postDisbursementVerified === true}
                          onChange={() =>
                            this.handleInputChange(
                              "postDisbursementVerified",
                              true
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="postDisbursementVerified"
                          type="radio"
                          checked={data.postDisbursementVerified !== true}
                          onChange={() =>
                            this.handleInputChange(
                              "postDisbursementVerified",
                              false
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default OriginalDocVerify;